<div class="relative h-full w-full overflow-hidden bg-black isolate">
  <div class="absolute top-0 left-0 h-full w-full">
    <app-preview-container-loader [isVisible]="(isLoaderVisible$ | async) ?? true"/>
  </div>

  <iframe #previewerView
          class="relative z-10 w-full h-full transition-opacity duration-500"
          [style.opacity]="((isLoaderVisible$ | async) ?? true) ? 0 : 1"
          [src]="launcherUrl$ | async"
          (load)="onIframeLoad()"></iframe>
</div>
